const semanaEdicoes = [
  {
    id: 1,
    slug: 2011,
    titulo: '1ª edição',
    ano: 2011,
    image: '/images/semanahiphop/2011/logo.png',
    chamada: 'Página dedicada à 1ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 1ª edição.',
    descricao: [
      'Adicione aqui o contexto da criação da 1ª edição, os objetivos daquele ano e os principais agentes envolvidos na realização do evento.',
      'Use este bloco para registrar artistas, locais, oficinas, debates e o impacto cultural e social específico desta edição.'
    ],
    destaques: [
      'Espaço para a logo oficial da 1ª edição.',
      'Espaço para line-up, programação e locais das atividades.',
      'Espaço para fotos, registros e memória da edição.'
    ],
    galeria: [
      'Foto principal da 1ª edição',
      'Registro de shows ou batalhas da 1ª edição',
      'Peça gráfica ou cartaz da 1ª edição'
    ]
  },
  {
    id: 2,
    slug: 2012,
    titulo: '2ª edição',
    ano: 2012,
    image: '/images/semanahiphop/2012/flyer.png',
    chamada: 'Página dedicada à 2ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 2ª edição.',
    descricao: [
      'Adicione aqui o histórico da 2ª edição, os destaques da programação e os avanços em relação ao ano anterior.',
      'Inclua informações sobre artistas convidados, ações em escolas, oficinas e demais atividades realizadas.'
    ],
    destaques: [
      'Espaço para a logo oficial da 2ª edição.',
      'Espaço para programação completa da edição.',
      'Espaço para parcerias, registros e memória do evento.'
    ],
    galeria: [
      'Foto principal da 2ª edição',
      'Registro de atividades da 2ª edição',
      'Peça gráfica ou cartaz da 2ª edição'
    ]
  },
  {
    id: 3,
    slug: 2013,
    titulo: '3ª edição',
    ano: 2013,
    image: '/images/semanahiphop/2013/logo_quadrado.png',
    chamada: 'Página dedicada à 3ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 3ª edição.',
    descricao: [
      'Adicione aqui o contexto da 3ª edição, incluindo o reconhecimento oficial do evento e os marcos institucionais do período.',
      'Use este espaço para detalhar atrações, atividades formativas e o alcance desta edição na cidade.'
    ],
    destaques: [
      'Espaço para a logo oficial da 3ª edição.',
      'Espaço para destacar o reconhecimento institucional do evento.',
      'Espaço para fotos, peças gráficas e memória da edição.'
    ],
    galeria: [
      'Foto principal da 3ª edição',
      'Registro de palco, breaking ou grafite da 3ª edição',
      'Peça gráfica ou cartaz da 3ª edição'
    ]
  },
  {
    id: 4,
    slug: 2014,
    titulo: '4ª edição',
    ano: 2014,
    image: '/images/semanahiphop/2014/logo.jpg',
    chamada: 'Página dedicada à 4ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 4ª edição.',
    descricao: [
      'Adicione aqui o resumo da 4ª edição, com informações sobre formato, circulação e alcance das atividades.',
      'Inclua os principais nomes envolvidos, as ações territoriais e o impacto cultural registrado neste ano.'
    ],
    destaques: [
      'Espaço para a logo oficial da 4ª edição.',
      'Espaço para atrações, oficinas e debates da edição.',
      'Espaço para registros e memória visual do evento.'
    ],
    galeria: [
      'Foto principal da 4ª edição',
      'Registro de oficinas ou debates da 4ª edição',
      'Peça gráfica ou cartaz da 4ª edição'
    ]
  },
  {
    id: 5,
    slug: 2015,
    titulo: '5ª edição',
    ano: 2015,
    image: '/images/semanahiphop/2015/logo.jpg',
    chamada: 'Página dedicada à 5ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 5ª edição.',
    descricao: [
      'Adicione aqui o panorama da 5ª edição e os principais elementos que marcaram a programação daquele ano.',
      'Use este bloco para contar como a edição ampliou a participação do público e fortaleceu a cena local.'
    ],
    destaques: [
      'Espaço para a logo oficial da 5ª edição.',
      'Espaço para programação e destaques culturais.',
      'Espaço para registros fotográficos e materiais visuais.'
    ],
    galeria: [
      'Foto principal da 5ª edição',
      'Registro de público ou show da 5ª edição',
      'Peça gráfica ou cartaz da 5ª edição'
    ]
  },
  {
    id: 6,
    slug: 2016,
    titulo: '6ª edição',
    ano: 2016,
    image: '/images/semanahiphop/2016/logo.jpg',
    chamada: 'Página dedicada à 6ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 6ª edição.',
    descricao: [
      'Adicione aqui o histórico da 6ª edição, os objetivos do ano e os principais parceiros envolvidos.',
      'Inclua dados sobre público, ações em território, artistas convidados e resultados da edição.'
    ],
    destaques: [
      'Espaço para a logo oficial da 6ª edição.',
      'Espaço para line-up, oficinas e atividades da edição.',
      'Espaço para fotos e materiais de divulgação.'
    ],
    galeria: [
      'Foto principal da 6ª edição',
      'Registro de atividades da 6ª edição',
      'Peça gráfica ou cartaz da 6ª edição'
    ]
  },
  {
    id: 7,
    slug: 2017,
    titulo: '7ª edição',
    ano: 2017,
    image: '/images/semanahiphop/2017/logo.jpg',
    chamada: 'Página dedicada à 7ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 7ª edição.',
    descricao: [
      'Adicione aqui o resumo da 7ª edição, indicando as principais frentes culturais, educativas e comunitárias mobilizadas.',
      'Use este espaço para registrar os destaques de programação e a repercussão local desta edição.'
    ],
    destaques: [
      'Espaço para a logo oficial da 7ª edição.',
      'Espaço para artistas convidados e programação.',
      'Espaço para fotos, registros e memória da edição.'
    ],
    galeria: [
      'Foto principal da 7ª edição',
      'Registro de palco ou batalha da 7ª edição',
      'Peça gráfica ou cartaz da 7ª edição'
    ]
  },
  {
    id: 8,
    slug: 2018,
    titulo: '8ª edição',
    ano: 2018,
    image: '/images/semanahiphop/2018/logo.jpg',
    chamada: 'Página dedicada à 8ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 8ª edição.',
    descricao: [
      'Adicione aqui a narrativa da 8ª edição, com foco nos principais acontecimentos, locais e artistas envolvidos.',
      'Inclua dados e relatos sobre oficinas, ações em escolas e presença nos espaços públicos da cidade.'
    ],
    destaques: [
      'Espaço para a logo oficial da 8ª edição.',
      'Espaço para programação detalhada da edição.',
      'Espaço para memória visual e registros do evento.'
    ],
    galeria: [
      'Foto principal da 8ª edição',
      'Registro de oficinas ou grafite da 8ª edição',
      'Peça gráfica ou cartaz da 8ª edição'
    ]
  },
  {
    id: 9,
    slug: 2019,
    titulo: '9ª edição',
    ano: 2019,
    image: '/images/semanahiphop/2019/logo.png',
    chamada: 'Página dedicada à 9ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 9ª edição.',
    descricao: [
      'Adicione aqui o histórico da 9ª edição e os elementos que fizeram deste ano um marco específico na trajetória do evento.',
      'Use este espaço para detalhar público, debates, parcerias, atrações e atividades desenvolvidas.'
    ],
    destaques: [
      'Espaço para a logo oficial da 9ª edição.',
      'Espaço para atrações e ações territoriais da edição.',
      'Espaço para fotos, materiais gráficos e registros.'
    ],
    galeria: [
      'Foto principal da 9ª edição',
      'Registro de público ou atividade da 9ª edição',
      'Peça gráfica ou cartaz da 9ª edição'
    ]
  },
  {
    id: 10,
    slug: 2022,
    titulo: '10ª edição',
    ano: 2022,
    image: '/images/semanahiphop/2022/logo.jpg',
    chamada: 'Página dedicada à 10ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 10ª edição.',
    descricao: [
      'Adicione aqui o panorama da 10ª edição, destacando a programação, os parceiros e os espaços ocupados pelo evento.',
      'Inclua os principais artistas, oficinas, atividades em escolas e resultados culturais desta edição.'
    ],
    destaques: [
      'Espaço para a logo oficial da 10ª edição.',
      'Espaço para programação, convidados e locais.',
      'Espaço para registros e memória do evento.'
    ],
    galeria: [
      'Foto principal da 10ª edição',
      'Registro de shows ou oficinas da 10ª edição',
      'Peça gráfica ou cartaz da 10ª edição'
    ]
  },
  {
    id: 11,
    slug: 2023,
    titulo: '11ª edição',
    ano: 2023,
    image: '/images/semanahiphop/2023/logo.jpg',
    chamada: 'Página dedicada à 11ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 11ª edição.',
    descricao: [
      'Adicione aqui o histórico da 11ª edição, os destaques da programação e os principais registros do evento.',
      'Use este espaço para consolidar artistas, público, oficinas, debates e o impacto cultural gerado neste ano.'
    ],
    destaques: [
      'Espaço para a logo oficial da 11ª edição.',
      'Espaço para atrações, programação e parceiros.',
      'Espaço para fotos, cartazes e memória da edição.'
    ],
    galeria: [
      'Foto principal da 11ª edição',
      'Registro de atividades da 11ª edição',
      'Peça gráfica ou cartaz da 11ª edição'
    ]
  },
  {
    id: 12,
    slug: 2024,
    titulo: '12ª edição',
    ano: 2024,
    image: '/images/semanahiphop/2024/logo.jpg',
    chamada: 'Página dedicada à 12ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 12ª edição.',
    descricao: [
      'Adicione aqui o histórico da 12ª edição, os destaques da programação e os principais registros do evento.',
      'Use este espaço para consolidar artistas, público, oficinas, debates e o impacto cultural gerado neste ano.'
    ],
    destaques: [
      'Espaço para a logo oficial da 12ª edição.',
      'Espaço para atrações, programação e parceiros.',
      'Espaço para fotos, cartazes e memória da edição.'
    ],
    galeria: [
      'Foto principal da 12ª edição',
      'Registro de atividades da 12ª edição',
      'Peça gráfica ou cartaz da 12ª edição'
    ]
  },
  {
    id: 13,
    slug: 2025,
    titulo: '13ª edição',
    ano: 2025,
    image: '/images/semanahiphop/2025/logo.jpg',
    chamada: 'Página dedicada à 13ª edição da Semana do Hip Hop de Bauru.',
    resumo: 'Espaço reservado para reunir a identidade visual, a programação, os destaques e os registros da 13ª edição.',
    descricao: [
      'Adicione aqui o histórico da 13ª edição, os destaques da programação e os principais registros do evento.',
      'Use este espaço para consolidar artistas, público, oficinas, debates e o impacto cultural gerado neste ano.'
    ],
    destaques: [
      'Espaço para a logo oficial da 13ª edição.',
      'Espaço para atrações, programação e parceiros.',
      'Espaço para fotos, cartazes e memória da edição.'
    ],
    galeria: [
      'Foto principal da 13ª edição',
      'Registro de atividades da 13ª edição',
      'Peça gráfica ou cartaz da 13ª edição'
    ]
  }
];

export default semanaEdicoes;